/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { ThemeOptions } from '@mui/material/styles';

interface CustomDpTypographyVariants {
	dpXxl?: React.CSSProperties;
	dpXl?: React.CSSProperties;
	dpLg?: React.CSSProperties;
	dpMd?: React.CSSProperties;
	dpSm?: React.CSSProperties;
	dpBody?: React.CSSProperties;
	dpDefault?: React.CSSProperties;
	dpSmall?: React.CSSProperties;
	dpCaption?: React.CSSProperties;
	dpTiny?: React.CSSProperties;
	dpMicro?: React.CSSProperties;
}

interface CustomDpTypographyPropsVariantOverrides {
	dpXxl: true;
	dpXl: true;
	dpLg: true;
	dpMd: true;
	dpSm: true;
	dpBody: true;
	dpDefault: true;
	dpSmall: true;
	dpCaption: true;
	dpTiny: true;
	dpMicro: true;
}

declare module '@mui/material/styles' {
	interface TypographyVariants extends CustomDpTypographyVariants {
		body1AsH1: React.CSSProperties;
		body1AsH2: React.CSSProperties;
		body2AsH2: React.CSSProperties;
		h3AsH1: React.CSSProperties;
		h4AsH1: React.CSSProperties;
		h6AsH2: React.CSSProperties;
		strong: React.CSSProperties;
	}

	// allow configuration using `createTheme`
	interface TypographyVariantsOptions extends CustomDpTypographyVariants {
		body1AsH1?: React.CSSProperties;
		body1AsH2?: React.CSSProperties;
		body2AsH2?: React.CSSProperties;
		h3AsH1?: React.CSSProperties;
		h4AsH1?: React.CSSProperties;
		h6AsH2?: React.CSSProperties;
		strong?: React.CSSProperties;
	}
}

// Update the Typography's variant prop options
declare module '@mui/material/Typography' {
	interface TypographyPropsVariantOverrides extends CustomDpTypographyPropsVariantOverrides {
		body1AsH1: true;
		body1AsH2: true;
		body2AsH2: true;
		h3AsH1: true;
		h4AsH1: true;
		h6AsH2: true;
		strong: true;
	}
}

export const typography: ThemeOptions = {
	typography: {
		htmlFontSize: 16,
		fontFamily: ['Open Sans', '"Helvetica Neue"', 'Arial', 'sans-serif'].join(','),
		strong: {
			fontWeight: 600,
		},
	},
};
